<template>
  <b-container id="dashboard">
    <p>Dashboard page works!</p>
  </b-container>
</template>

<script>
export default {
  name: "Dashboard"
};
</script>

<style scoped></style>
